export enum CommLocationEnum {
  HOME = '0000000A-1000-0000-0000-000000000001',
  WORK = '0000000A-1000-0000-0000-000000000002',
  VACATION = '0000000A-1000-0000-0000-000000000003',
  PrivateWork = '0000000A-1000-0000-0000-000000000004',
}
